/*
 * @Author: cc
 * @LastEditTime: 2025-07-10 11:14:16
 */
import { useLocation } from "react-router-dom";
import {useState,useEffect} from "react"
/**一体化组件 */
import Integration from "../component/integration"
/**独立密码组件 */
import Independent from "../component/independent"
import "./index.scss";
import {connect} from "react-redux"
import {Modal} from "antd"
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
/**登录页面组件 */
function Login(props:any) {
  const infoData = props.initData
  const [videoModal,setVideoModal] = useState(false)
  const [currentVideo,setCurrentVideo] = useState(null)
  const initVideo = (vid: string) => {
    if (window.createCCH5Player) {
      window.ccPlayerStatus = window.createCCH5Player({
        vid,
        siteid:'D71B0368E20B4CF5',
        autoStart: true,
        width: "100%" ,
        height: "300px",
        banDrag: "false",
        playtype: 1,
        rate_allow_change: false,
        parentNode: document.getElementById("livePlayer"),
      });
    }
  };
  useEffect(()=>{
    if(videoModal){
      initVideo(currentVideo.adContent)
    }
  },[currentVideo])
  return (
    <>
      <div className="wrapper">
        <div style={{ width: "70%", margin: "0 auto" }}>
          {infoData.pcTopImageUrl && (
            <img
              style={{ maxHeight: "150px" }}
              src={infoData.pcTopImageUrl}
              alt=""
            ></img>
          )}
          <div className="content">
            <img
              style={{ maxWidth: "100%" }}
              src={infoData.pcMainImageUrl}
              alt=""
            ></img>
            <div className="login">
              {infoData.verifyLoginMode === 1 ? (
                <Integration></Integration>
              ) : (
                <Independent></Independent>
              )}
            </div>
          </div>
          {infoData.pcBottomImageUrl && (
            <img
              style={{ marginTop: "20px", maxHeight: "100px" }}
              src={infoData.pcBottomImageUrl}
              alt=""
            ></img>
          )}
          {infoData.adPositionName && (
            <h2 style={{ marginTop: "20px" }}>{infoData.adPositionName}</h2>
          )}
          {infoData.adPositionInfoList &&
            infoData.adPositionInfoList.length > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                {infoData.adPositionInfoList.map((item: any, index: number) => {
                  return (
                    <a
                      style={{ width: "18%", margin: "10px" }}
                      onClick={() => {
                        if (item.adMode === 2) {
                          setVideoModal(true);
                          setCurrentVideo(item);
                        } else {
                          window.location.href = item.adContent;
                        }
                      }}
                      key={index}
                    >
                      <img
                        src={item.adImageUrl}
                        style={{
                          width: "100%",
                          height: "100px",
                          display: "block",
                        }}
                        alt=""
                      ></img>
                    </a>
                  );
                })}
              </div>
            )}
        </div>
      </div>
      <Modal
        open={videoModal}
        closable={false}
        cancelText="关闭"
        onOk={() => {
          setVideoModal(false);
        }}
        onCancel={() => {
          setVideoModal(false);
        }}
      >
        <div id="livePlayer"></div>
      </Modal>
    </>
  );
}
const getInitData = (state: { initData: Array<any> }) => {
  return {
    initData: state.initData,
  };
};
export default connect(getInitData)(Login)
